import { Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { IconType } from '@kinomap-dev/ng-ui-lib/core';
import { SynchroStatusType } from '../../types/synchroStatus.type';
import { ColorService } from '../../services/color.service';
import { IconComponent } from '@kinomap-dev/ng-ui-lib/basics';

import { TranslateModule } from '@ngx-translate/core';

/**
 * Bloc d'information purement visuel (icône, titre, message).
 * Les actions éventuelles sont projetées via `<ng-content />`.
 */
@Component({
  selector: 'app-syncro-information',
  imports: [TranslateModule, IconComponent],
  template: `
    <kin-icon [name]="icon()" [color]="iconColor()" />
    <div class="texts">
      <h3>{{ title() | translate }}</h3>
      <p>{{ message() | translate }}</p>
    </div>
    <div class="actions">
      <ng-content />
    </div>
  `,
  host: {
    class: 'synchro-tips display-animations',
    '[class]': 'status()',
    '[class.requieredError]': 'requieredError()',
  },
  styleUrl: './syncro-information.scss',
})
export class SyncroInformation {
  private colorService: ColorService = inject(ColorService);

  requieredError: InputSignal<boolean> = input<boolean>(false);
  status: InputSignal<SynchroStatusType> = input.required<SynchroStatusType>();
  title: InputSignal<string> = input.required<string>();
  message: InputSignal<string> = input.required<string>();
  icon: InputSignal<IconType> = input.required<IconType>();

  protected readonly iconColor: Signal<string> = computed(() => {
    switch (this.status()) {
      case 'complete':
        return this.colorService.success() || '#46A610';
      case 'error':
        return this.colorService.danger500() || '#FF2929';
      case 'speed-warning':
        return this.colorService.warn() || '#FFA729';
      default:
        return this.colorService.brandSecondary() || '#68A5F5';
    }
  });
}
